import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useSEO, generateFAQSchema, generateBreadcrumbSchema, generateWebPageSchema } from '../../utils/seo';

export default function SSS() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqs = [
    {
      question: "İlkyardım sertifikası ne kadar süre geçerlidir?",
      answer: "Sağlık Bakanlığı düzenlemelerine göre ilkyardım sertifikası 3 yıl süreyle geçerlidir. Bu süre sonunda yenileme eğitimi alarak sertifikanızı yenileyebilirsiniz."
    },
    {
      question: "Osmaniye'de ilkyardım eğitimi ücretleri nelerdir?",
      answer: "Eğitim ücretleri Sağlık Bakanlığı tarafından belirlenmektedir ve her yıl güncellenebilmektedir. Güncel fiyat bilgisi için lütfen bizimle iletişime geçin. Kurumsal eğitimler için özel fiyat teklifi hazırlanmaktadır."
    },
    {
      question: "Kurumsal eğitim nasıl organize edilir?",
      answer: "10 kişi ve üzeri gruplar için kurumsal eğitim organize ediyoruz. Eğitim firmanızda veya merkezimizde yapılabilir. Özel fiyat teklifi için bizimle iletişime geçin."
    },
    {
      question: "İlkyardım eğitiminde hangi konular işlenir?",
      answer: "Temel yaşam desteği (CPR), yaralanma müdahaleleri, kırık ve çıkık, zehirlenmeler, yanık müdahaleleri, bilinçsizlik durumları ve acil durum yönetimi konuları detaylı olarak işlenir."
    },
    {
      question: "İlkyardım sertifikası hangi kurumlarda geçerlidir?",
      answer: "Sağlık Bakanlığı onaylı sertifikamız tüm kamu kurumları, özel şirketler, üniversiteler ve işyerlerinde geçerlidir. Ehliyet alımında da kabul edilmektedir."
    },
    {
      question: "Eğitim öncesi hazırlık gerekli mi?",
      answer: "Herhangi bir ön bilgi gerekmemektedir. Eğitimlerimiz sıfırdan başlayıp tüm konuları kapsamaktadır. Sadece rahat kıyafet giymenizi öneriyoruz."
    },
    {
      question: "İptal ve iade koşulları nelerdir?",
      answer: "Eğitim tarihinden 48 saat öncesine kadar ücretsiz iptal edilebilir. Bu süre sonrası iptal durumunda %50 kesinti yapılır. Eğitim günü iptal durumunda iade yapılmaz."
    },
    {
      question: "Online ilkyardım eğitimi seçeneği var mı?",
      answer: "İlkyardım eğitimi uygulamalı olması gerektiği için tamamen yüz yüze yapılmaktadır. Ancak teorik kısımlar için destekleyici online materyaller sunulmaktadır."
    },
    {
      question: "Eğitim materyalleri verilir mi?",
      answer: "Evet, eğitim kitapçığı, sertifika ve katılım belgesi ücretsiz verilir. Ayrıca dijital materyallere erişim imkanı da sunulmaktadır."
    },
    {
      question: "İlkyardım eğitimi için yaş sınırı var mı?",
      answer: "Minimum yaş sınırı 16'dır. 16-18 yaş arası katılımcılar için veli onayı gerekmektedir. Üst yaş sınırı bulunmamaktadır."
    },
    {
      question: "Eğitim başarısızlık durumunda ne olur?",
      answer: "Teorik ve uygulamalı sınavlarda başarısız olunması durumunda ücretsiz tekrar hakkı verilir. İkinci tekrarda da başarısız olunursa ek ücret karşılığında eğitim tekrarlanır."
    },
    {
      question: "Özel durumlar için uyarlama var mı?",
      answer: "Engelli katılımcılar için özel uyarlama yapılmaktadır. Önceden bildirmeniz durumunda gerekli düzenlemeler yapılır. Detaylar için bizimle iletişime geçin."
    }
  ];

  // SEO Configuration
  useSEO({
    title: 'Sıkça Sorulan Sorular | Osmaniye İlkyardım Eğitimi SSS - ASSA Akademi',
    description: 'Osmaniye ilkyardım eğitimi hakkında sıkça sorulan sorular: Sertifika geçerliliği, eğitim ücretleri, kurumsal eğitim, kayıt koşulları. ASSA Akademi SSS sayfası.',
    keywords: 'ilkyardım eğitimi sss, Osmaniye ilkyardım sertifikası geçerlilik, eğitim ücretleri Osmaniye, kurumsal eğitim sss, ilkyardım eğitimi sorular cevaplar',
    canonical: '/sss',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateBreadcrumbSchema([
          { name: 'Ana Sayfa', url: '/' },
          { name: 'SSS', url: '/sss' }
        ]),
        generateWebPageSchema('Sıkça Sorulan Sorular', 'Osmaniye ilkyardım eğitimi hakkında sıkça sorulan sorular ve cevapları', '/sss'),
        generateFAQSchema(faqs)
      ]
    }
  });

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-6">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/d976ad48ea6e824eb2b305836503c616.jfif" 
                alt="ASSA Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 cursor-pointer">Ana Sayfa</Link>
              <Link to="/egitimlerimiz" className="text-gray-700 hover:text-blue-600 cursor-pointer">Eğitimlerimiz</Link>
              <Link to="/hakkimizda" className="text-gray-700 hover:text-blue-600 cursor-pointer">Hakkımızda</Link>
              <Link to="/sss" className="text-blue-600 font-semibold cursor-pointer">SSS</Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-blue-600 cursor-pointer">İletişim</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(37, 99, 235, 0.85), rgba(37, 99, 235, 0.7)), url('https://public.readdy.ai/ai/img_res/ad162a4f0413fb063b82b2ef451c3adf.jpg')`
        }}
      >
        <div className="container mx-auto px-6 text-white">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Sıkça Sorulan Sorular</h1>
            <p className="text-xl mb-8 leading-relaxed">
              İlkyardım eğitimlerimiz hakkında merak ettiğiniz soruların yanıtlarını burada bulabilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Sık Sorulan Sorular</h2>
              <p className="text-xl text-gray-600">
                Eğitimlerimiz, sertifikalarımız ve süreçlerimiz hakkında detaylı bilgiler
              </p>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-gray-50 transition-colors cursor-pointer"
                  >
                    <h3 className="text-lg font-semibold text-gray-800 pr-4">
                      {faq.question}
                    </h3>
                    <div className={`w-8 h-8 flex items-center justify-center transition-transform duration-200 ${
                      openFaq === index ? 'rotate-180' : ''
                    }`}>
                      <i className="ri-arrow-down-s-line text-2xl text-blue-600"></i>
                    </div>
                  </button>

                  <div className={`overflow-hidden transition-all duration-300 ${
                    openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}>
                    <div className="px-8 pb-6">
                      <p className="text-gray-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Quick Info Cards */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Hızlı Bilgiler</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              En çok merak edilen konularda özet bilgiler
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl border border-blue-200">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Eğitim Süreleri</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Temel İlkyardım: 16 saat (2 gün)</li>
                <li>• Yenileme Eğitimi: 8 saat (1 gün)</li>
                <li>• Kurumsal: Esnek süre</li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl border border-green-200">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Eğitim İçeriği</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• CPR ve Temel Yaşam Desteği</li>
                <li>• Yaralanma Müdahaleleri</li>
                <li>• Acil Durum Yönetimi</li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-xl border border-purple-200">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Sertifika Bilgisi</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Geçerlilik: 3 yıl</li>
                <li>• Tüm sektörlerde kabul</li>
                <li>• Sağlık Bakanlığı onaylı</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Başka Sorularınız mı Var?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Aradığınız soruyu bulamadınız mı? Size yardımcı olmaktan mutluluk duyarız. 
            Uzman ekibimizle iletişime geçin.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/iletisim"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Bize Sorun
            </Link>
            <div className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center">
              <i className="ri-phone-line mr-2"></i>
              0850 346 2772
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <p className="text-gray-300 leading-relaxed mb-6">
                Sağlık Bakanlığı onaylı ilkyardım eğitimleri ile hayat kurtarmayı öğrenin.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Hızlı Linkler</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">
                    Ana Sayfa
                  </Link>
                </li>
                <li>
                  <Link to="/egitimlerimiz" className="text-gray-300 hover:text-white cursor-pointer">
                    Eğitimlerimiz
                  </Link>
                </li>
                <li>
                  <Link to="/hakkimizda" className="text-gray-300 hover:text-white cursor-pointer">
                    Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link to="/iletisim" className="text-gray-300 hover:text-white cursor-pointer">
                    İletişim
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Eğitimler</h4>
              <ul className="space-y-3">
                <li>
                  <span className="text-gray-300">İSG Temel Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">Yüksekte Çalışma</span>
                </li>
                <li>
                  <span className="text-gray-300">Yangın Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">İlkyardım Eğitimi</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">İletişim</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-phone-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">0850 346 2772</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">info@assaakademi.com.tr</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-blue-400 mr-3 mt-1"></i>
                  <span className="text-gray-300">Adnan Menderes, Emniyet Cd. 28/B, 80010 Osmaniye Merkez/Osmaniye</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 mt-12">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 mb-4 md:mb-0">
                © 2024 Assa İş Eğitimleri Akademisi. Tüm hakları saklıdır.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/+905324196401"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse cursor-pointer"
          title="WhatsApp ile iletişime geç"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}
